import { render, staticRenderFns } from "./PassIndex.vue?vue&type=template&id=4565c82c&scoped=true"
import script from "./PassIndex.vue?vue&type=script&lang=js"
export * from "./PassIndex.vue?vue&type=script&lang=js"
import style0 from "./PassIndex.vue?vue&type=style&index=0&id=4565c82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565c82c",
  null
  
)

export default component.exports